import { api_configuration } from "../../common";
import api_client_state = api_configuration.types.client_state.alan_api;
import { IdPathBuilder } from "./IdPathBuilder";

export default function (id_path: api_client_state.Cid_path): IdPathBuilder {
	return buildIdPath(id_path, IdPathBuilder.create());
}

function buildIdPath(id_path: api_client_state.Cid_path, current_builder: IdPathBuilder): IdPathBuilder {
	return id_path.properties.has_steps.switch({
		no: current_builder,
		yes: ($) =>
			buildIdPath(
				$.properties.tail,
				$.properties.type.switch({
					"collection entry": ($) => current_builder.collectionEntry($.properties.collection.entry, $.properties.id),
					group: ($) => current_builder.group($.properties.group.entry),
					state: ($) => current_builder.state($.properties.state_group.entry, $.properties.state.entry),
				})
			),
	});
}
